import PropTypes from 'prop-types';
import React from 'react';

import { Alert, Modal } from 'opencare-crown';

import { useRedirectionService } from 'services/RedirectionService';

import CONFIG from '../../../../../../app.config';
import {
  FlexCol,
  FlexRow,
  P,
} from '../../../../../common/styles/oc-styled-components';
import { colors } from '../../../../../common/styles/style-constants';
import { ButtonBlock } from '../../../styled-components';

import {
  BadgeButton,
  BadgeWrapper,
  CheckCircleIcon,
  IconContainer,
} from './styled-components';

const CompletedFormBadge = ({ firstName, dataTestId, style }) => {
  const redirectionService = useRedirectionService();

  const redirectUser = () => {
    redirectionService.redirect({
      url: CONFIG.SEARCH_APP_URL,
      reason: 'completed-form-badge-return-to-homepage',
    });
  };

  return (
    <Modal closable={false} visible footer={null} centered>
      <Alert
        data-testid={dataTestId}
        role="alert"
        tabIndex="0"
        type="warning"
        style={{
          ...style,
          backgroundColor: 'rgba(154,190,181, 0.1)',
        }}
        message={(
          <BadgeWrapper>
            <FlexRow align="center">
              <IconContainer>
                <CheckCircleIcon type="CheckCircle" />
              </IconContainer>
              <FlexCol justify="flex-start">
                <P textAlign="initial" color={colors.sage8}>
                  Request sent! Thanks {firstName}.
                </P>
                <P textAlign="initial" fontWeight="bold" color={colors.sage8}>
                  A member of our Opencare Concierge team will reach out within
                  the next 5 minutes!
                </P>
              </FlexCol>
            </FlexRow>
          </BadgeWrapper>
        )}
      />

      <ButtonBlock>
        <BadgeButton onClick={redirectUser}>Return to Opencare.com</BadgeButton>
      </ButtonBlock>
    </Modal>
  );
};

CompletedFormBadge.propTypes = {
  firstName: PropTypes.string.isRequired,
  dataTestId: PropTypes.string,
  style: PropTypes.object,
};

export default CompletedFormBadge;
